import React from 'react';
import {
    BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, Legend, LabelList, ResponsiveContainer
} from 'recharts';

const NegativeBarChartComponent = ({ data, dataLabels, chartLabel, dataKeys }) => {
    const formatCurrency = (value) => {
        return new Intl.NumberFormat("pt-BR", { style: "currency", currency: "BRL" }).format(value);
    };

    const CustomLabel = ({ x, y, value }) => {
        const isNegative = value < 0;
        return (
            <text
                x={x + 35}
                y={isNegative ? y + 20 : y - 10} // abaixo da barra se negativo
                fill={isNegative ? "red" : "#000"}
                fontSize={12}
                textAnchor="middle"
            >
                {formatCurrency(value)}
            </text>
        );
    };

    return (
        <ResponsiveContainer width="100%" height={400}>
            <BarChart
                data={data}
                margin={{ top: 20, right: 30, left: 40, bottom: 5 }}
            >
                <CartesianGrid strokeDasharray="3 3" />
                <XAxis dataKey={chartLabel} />
                <YAxis domain={['auto', 'auto']} />
                <Tooltip formatter={(value) => formatCurrency(value)} />
                <Legend />

                <Bar dataKey={dataKeys[0]} fill="#FDBE34" name={dataLabels[0]}>
                    <LabelList dataKey={dataKeys[0]} content={<CustomLabel />} />
                </Bar>
                <Bar dataKey={dataKeys[1]} fill="#67B26F" name={dataLabels[1]}>
                    <LabelList dataKey={dataKeys[1]} content={<CustomLabel />} />
                </Bar>
                <Bar dataKey={dataKeys[2]} fill="#F5A571" name={dataLabels[2]}>
                    <LabelList dataKey={dataKeys[2]} content={<CustomLabel />} />
                </Bar>
            </BarChart>
        </ResponsiveContainer>
    );
}

export default NegativeBarChartComponent;